import symbolOrderDetailAPI from '@webtrader/core/api/market/symbols/order';

import OrderFormService from '../service';

class EditOrderFormService extends OrderFormService {
  constructor() {
    super();

    this.setIsEdit(true);
  }

  public fetchSymbolOrderDetails = async (symbol: string) => {
    try {
      this.context.loadingSymbolDetails = true;

      const { result } = await symbolOrderDetailAPI({
        symbol
      });

      this.context.symbolDetails = result || undefined;
    } catch (error) {
    } finally {
      this.context.loadingSymbolDetails = false;
    }
  };
}

export default new EditOrderFormService();
